module.exports = __webpack_public_path__ + "img/117.25038aab.webp";